<div class="card" id="islas-card">
    <div class="card-header">
      <h4 style="display: inline;" class="card-title">ABM de Equipos.</h4>
      <button *ngIf="this.hasRole(TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.RESPRODUCTO, TipoUsuario.TUTOR)" style="margin-left: 4em;" class="btn btn-primary" type="button" [disabled]="this.obteniendoEquipos"
        (click)="abrirModal(false, null)">Agregar nuevo equipo</button>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="spinner-container" *ngIf="this.obteniendoEquipos">            
            <ngx-spinner name="spinnerEquipos" bdOpacity=0.3bd
              Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
              <p style="color: white">{{messageEquipos}}</p>
            </ngx-spinner>            
          </div>
          <div *ngIf="this.equipos.length == 0 && !obteniendoEquipos" class="alert alert-warning">No hay equipos fijos
            para la aeroplanta seleccionada.</div>
          
          <table *ngIf="this.equipos.length > 0 && !this.obteniendoEquipos" class="table table-striped table-hover col-md-6"
            [formGroup]="tablaEquipos">
            <thead>
              <th class="text-center">Nombre</th>
              <th class="text-center">Editar</th>
              <th class="text-center">Estado actual</th>
              <th class="text-center">Acción</th>
            </thead>
            <tbody>
              <tr formArrayName="equiposForm" *ngFor="let e of equipos; let i = index">
                <td class="text-center">{{e.nombre}}</td>
                <td class="text-center">
                  <button type="button" class="btn btn-primary btn-sm me-1" (click)="abrirModal(true, i, e)"><i class="fa fa-pencil fa-lg"
                      aria-hidden="true" ngbTooltip="Editar"></i></button>
                </td>
                <td class="text-center">
                  <select [formControlName]="i" class="form-select" ngbTooltip="Seleccione el estado.">
                    <option *ngFor="let estado of keysEstados()" [ngValue]="obtenerEstado(estado)">
                      {{estado}}
                    </option>
                  </select>
                  <div class="alert alert-danger"
                    *ngIf="(this.equipos[i].invalid && this.equipos[i].errors.required && (this.equipos[i].dirty || this.equipos[i].touched))">
                    Debe seleccionar un estado obligatoriamente.
                  </div>                  
                </td>
                <td class="text-center">
                  <button type="button" [disabled]="mismoEstado(equipos[i])" class="btn btn-primary btn-sm me-1" aria-hidden="true" (click)="abrirModal(false, i, equipos[i])">
                    <span *ngIf="!guardandoEstado[i]">Guardar</span>
                      <div *ngIf="guardandoEstado[i]" class="d-flex align-items-center">
                        <div class="spinner-border text-light spinner-border-sm" role="status"></div>
                        <span>Guardando...</span>
                      </div>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>  
        </div>
      </div>
    </div>
